export type ErrorState = {
  type: ErrorStateType|null;
  reason: string|undefined;
};

export type TelegramLoginData = {
  id: number;
  auth_date: number;
  first_name: string;
  hash: string;
  photo_url: string;
  username: string;
};

export enum ErrorStateType {
  GENERIC_ERROR = 1,
  BANNED = 2
}